import validate from 'validate.js';
import * as yup from 'yup';

/**
 * Validates a LinkedIn URL using Yup.
 *
 * @param {string} url - The URL to validate.
 * @returns {Promise<any>} The result of the validation.
 */
export const validateLinkedinURL = async (url) => {
  let schema = yup
    .string()
    .url('Please enter a valid URL')
    .matches(
      /http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?/,
      'Please enter a valid linkedin URL',
    );

  return await schema.validate(url);
};

/**
 * Validates an email address.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} True if the email is valid, false otherwise.
 */
export const validateEmail = (email) => {
  return validate({ email: email }, { email: { email: true } }) === undefined;
};

/**
 * Validates a URL using Yup.
 *
 * @param {string} url - The URL to validate.
 * @returns {Promise<any>} The result of the validation.
 */
export const validateURL = async (url) => {
  let schema = yup.string().url('Please enter a valid url');

  return await schema.validate(url);
};

/**
 * Validates a date string in MM-DD-YYYY format.
 *
 * @param {string} dateStr - The date string to validate.
 * @returns {boolean} True if the date string is valid, false otherwise.
 */
export const isValidMMDDYYYY = (dateStr) => {
  // Match format using regex: MM-DD-YYYY
  const regex = /^(0[1-9]|1[0-2])-([0-2][0-9]|3[01])-\d{4}$/;
  if (!regex.test(dateStr)) return false;

  const [month, day, year] = dateStr.split('-').map(Number);

  // Create date object
  const date = new Date(year, month - 1, day);

  // Check if the date matches the input
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

/**
 * Checks if the error is a "Public Key Missing" error from Vapi.
 *
 * @param {Object} errorObj - The error object.
 * @param {Object} errorObj.vapiError - The Vapi error object.
 * @returns {boolean} True if the error matches, false otherwise.
 */
export const isPublicKeyMissingError = ({ vapiError }) => {
  return (
    !!vapiError &&
    vapiError.error.statusCode === 403 &&
    vapiError.error.error === 'Forbidden'
  );
};
